export interface ILateRexmCompliance {
    id: number,
    donorCenterId: number,
    donorCenterAlias: string,
    donorId: number,
    donorAlias: string,
    donorIsExportable: boolean,
    recipientCenterId: number,
    recipientCenterAlias: string,
    recipientId: number,
    recipientAlias: string,
    recipientIsExportable: boolean,
    dateRequested: string,
    responseDateTime: string,
    responseDetails: string,
    safeKey: string,
    expectedResponseDate: string,
    secondsLate: number,
    isLate: boolean,
    isPending: boolean,
    daysLate: number,
}